export enum Sexo {
    Masculino = "masculino",
    Femenino = "femenino",
    Indicar = "indicar sexo",
}
